export default __webpack_public_path__ + "static/apple-touch-icon-152x152-8c81308ac8d760eada18f815c4bb904a.png";